import { Component } from '@angular/core';
import { SelectTemplate } from 'src/app/@amiga-pyme/select/templates/select.template';
import {
  ITherapistGroup,
  THERAPIST_GROUP_TTL_ES
} from '../../therapist-group.interface';
import { TherapistGroupService } from '../../therapist-group.service';

@Component({
  selector: 'pg-therapist-group-select',
  template: `
    <ami-select
      [settings]="table.settings"
      [data]="table.data"
      (selectedRowsEvent)="onReciveSelectedRows($event)"
    ></ami-select>
  `
})
export class TherapistGroupSelectComponent extends SelectTemplate {
  constructor(private serviceBase: TherapistGroupService) {
    super(THERAPIST_GROUP_TTL_ES, serviceBase);
  }

  ngOnInit() {
    this.table.settings = {
      title: THERAPIST_GROUP_TTL_ES,
      columns: [{ header: 'Descripción', field: 'description' }]
    };
    this.initSubscriptions$();
  }

  initSubscriptions$() {
    this.suscriptionBase$ = this.serviceBase
      .getData$()
      .subscribe((data: ITherapistGroup[]) => {
        this.table.data = data;
      });
  }

  ngOnDestroy() {
    this.unsubscribeBase();
  }
}
